<div class="revio-body">
  <div class="kpi">
    @if (loading) {
      <p-progressSpinner styleClass="kpi-spinner" strokeWidth="4" />
    } @else if (!error) {
      <div class="kpi-value">{{ data.customers | number }}</div>
    } @else {
      <span class="kpi-error"><i class="pi pi-exclamation-triangle"></i></span>
    }
    <div class="kpi-label">Parent Customers</div>
  </div>
  <div class="kpi">
    @if (loading) {
      <p-progressSpinner styleClass="kpi-spinner" strokeWidth="4" />
    } @else if (!error) {
      <div class="kpi-value">{{ data.sites | number }}</div>
    } @else {
      <span class="kpi-error"><i class="pi pi-exclamation-triangle"></i></span>
    }
    <div class="kpi-label">Sites (Child Customers)</div>
  </div>
</div>

@if (!loading && error) {
  <div class="revio-error">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ error }}</span>
  </div>
}
